module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/aiCreation/components/AiVideoItem/asset/close.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/aiCreation/components/AiVideoItem/asset/close.png
// module id = 657
// module chunks = 367